import { FunctionFactory } from 'survey-core';
import { Gender } from '../quiz/gender';
import { getTestimonialByName } from './testimonials';
import { getGenderKey } from '../features/utils';
import { Physiology } from '../quiz/physiology';
import { locHtml } from './locHtml';
import { makeSplashHeader } from './SplashHeader';
import { tSurvey } from '../i18n/survey';

const muscleFocusSplashHtml = locHtml((t) => `
<div class="new-quote-container">
  <div class="quote-img-container" style="margin-top: 16px">
    <img src="{muscleFocusImgUrl}" alt="${t("splash.testimonialAlt")}" />
  </div>
  <div class="image-footnote">{muscleFocusQuoterName} – ${t("splash.realMember")}</div>
  <div class="quote">
    {muscleFocusQuote}
  </div>
</div>`);

const muscleFocusQuoteExpression = {
  name: "muscleFocusQuote",
  expression: "renderMuscleFocusQuote({gender}, {physiology})",
};

const muscleFocusImgUrlExpression = {
  name: "muscleFocusImgUrl",
  expression: "renderMuscleFocusImgUrl({gender}, {physiology})",
}

const muscleFocusQuoterNameExpression = {
  name: "muscleFocusQuoterName",
  expression: "renderMuscleFocusQuoterName({gender}, {physiology})",
}

function renderMuscleFocusQuote(params: any[]): string {
  if (params === undefined || params === null) return "";
  const gender = params[0] as Gender;
  const physiology = params[1] as Physiology;
  const genderKey = getGenderKey(gender, physiology);

  switch (genderKey) {
    case Gender.Male: {
      return tSurvey("splash.muscleFocusQuote.patrick");
    }
    case Gender.Female: {
      return tSurvey("splash.muscleFocusQuote.tahnee");
    }
  }
}

function renderMuscleFocusQuoterName(params: any[]): string {
  if (params === undefined || params === null) return "";
  const gender = params[0] as Gender;
  const physiology = params[1] as Physiology;
  const genderKey = getGenderKey(gender, physiology);

  switch (genderKey) {
    case Gender.Male: {
      return `Patrick R.`;
    }
    case Gender.Female: {
      return `Tahnee S.`;
    }
  }
}


function renderMuscleFocusImgUrl(params: any[]): string {
  if (params === undefined || params === null) return "";
  const gender = params[0] as Gender;
  const physiology = params[1] as Physiology;
  const genderKey = getGenderKey(gender, physiology);

  switch (genderKey) {
    case Gender.Male: {
      return getTestimonialByName('Patrick R.').image;
    }
    case Gender.Female: {
      return getTestimonialByName('Tahnee S.').image;
    }
  }
}

FunctionFactory.Instance.register("renderMuscleFocusQuote", renderMuscleFocusQuote);
FunctionFactory.Instance.register("renderMuscleFocusImgUrl", renderMuscleFocusImgUrl);
FunctionFactory.Instance.register("renderMuscleFocusQuoterName", renderMuscleFocusQuoterName);

const MuscleFocusSplashHeader = makeSplashHeader("splash.headers.muscleFocus");

const muscleFocusSplashElement = {
  name: 'muscle-focus-splash',
  type: 'html',
  html: muscleFocusSplashHtml,
};

export {
  muscleFocusSplashElement,
  muscleFocusQuoteExpression,
  muscleFocusImgUrlExpression,
  muscleFocusQuoterNameExpression,
  MuscleFocusSplashHeader,
}
